<app-header [title]="'License Batches'">
  <app-button
    *ngIf="isMasterAdmin"
    [black]="true"
    [title]="'+ Create Batch'"
    (click)="navigateToCreateBatch()"
    header-button
  ></app-button>
</app-header>

<div class="toolbar">
  <div class="search-field">
    <app-input
      [placeholder]="'Search license batches'"
      (inputValue)="onSearchChange($event)"
    ></app-input>
  </div>
  <div
    class="result-count"
    *ngIf="!licenseBatchStore.loading() && !licenseBatchStore.error()"
  >
    {{ filteredBatches.length }} batch{{
      filteredBatches.length === 1 ? '' : 'es'
    }}
  </div>
</div>

<div class="status-card" *ngIf="licenseBatchStore.loading()">
  Loading license batches...
</div>

<div class="status-banner" *ngIf="licenseBatchStore.error()">
  <app-response-banner
    [success]="false"
    [errorMessage]="getErrorMessage(licenseBatchStore.error())"
    [invisible]="false"
  ></app-response-banner>
</div>

<div
  class="status-card"
  *ngIf="
    !licenseBatchStore.loading() &&
    !licenseBatchStore.error() &&
    filteredBatches.length === 0
  "
>
  No license batches found.
</div>

<div
  class="list"
  *ngIf="
    !licenseBatchStore.loading() &&
    !licenseBatchStore.error() &&
    filteredBatches.length > 0
  "
>
  <app-license-batch-card
    *ngFor="let batch of filteredBatches; trackBy: trackByBatch"
    [batch]="batch"
    [showEditAction]="isMasterAdmin"
    [showManageDevicesAction]="canManageLicenseAssignments"
    [showDeleteAction]="isMasterAdmin"
    (viewBatch)="navigateToBatchDetails($event)"
    (editBatch)="navigateToEditBatch($event)"
    (manageDevices)="navigateToManageDevices($event)"
    (manageUsers)="navigateToManageUsers($event)"
    (deleteBatch)="deleteBatch($event)"
  ></app-license-batch-card>
</div>
